/**
 * Para onde leva o clique numa venda da lista. Pedido de produto abre o
 * detalhe do pedido; venda de link abre a lista de links já filtrada pelo
 * comprador (lá estão o histórico de cobranças e as ações do link). Assinatura
 * nativa não tem tela de detalhe.
 */
export const vendaTemDetalhe = (row) =>
  (row.source === 'produto' && Boolean(row.order_id)) ||
  (row.source === 'link' && Boolean(row.cpf || row.customer_name));

export const rotaDaVenda = (row) => {
  if (row.source === 'produto') return `/owner/sales/${row.order_id}`;
  const busca = encodeURIComponent(row.cpf || row.customer_name || '');
  return `/owner/payment-links?busca=${busca}`;
};
